import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { projectStatusList } from '@/module/Author/Project';

import { authorSchema, identitySchema, publishedAtSchema } from '@/core/components';

import { currencyList } from '@feature/utils';

export const statusYearSchema = z.object({
  year: z.number(),
  status: z.enum(projectStatusList),
});

export const financingSchema = z.object({
  type: identitySchema.nullable(),
  financerName: z.string().nullable(),
});

export const projectSchema = z.object({
  title: z.string().min(3),
  contractValue: z.number(),
  currency: z.enum(currencyList),
  statusYear: z.array(statusYearSchema),
  competitionName: z.string().nullable(),
  competition: identitySchema.extend({
    name: z.string(),
  }),

  financing: financingSchema.nullable(),
  competitionType: identitySchema.nullable(),
  registrationNumber: z.string().nullable(),
  contractNo: z.string().nullable(),
  startDate: publishedAtSchema,
  endDate: publishedAtSchema,

  percentObtainedOfMinScore: z.number().nullish(),

  contribution: identitySchema.nullable(),

  authors: z.array(authorSchema).min(1),
});

export const defaultProjectValues: DefaultValues<ProjectSchema> = {
  title: '',
  contractValue: 0,
  currency: 'RON',
  statusYear: [],
  competitionName: '',
  financing: {
    financerName: '',
  },
  registrationNumber: '',
  contractNo: '',
};

export type ProjectSchema = z.infer<typeof projectSchema>;
export type StatusYearSchema = z.infer<typeof statusYearSchema>;
